'use client'

export default function Error({
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <p>Une erreur est survenue. Veuillez réessayer.</p>
            <button onClick={reset}>Réessayer</button>
        </div>
    )
}
